import React from "react";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

const navItems = [
  { href: "#services", label: "Services" },
  { href: "#doctors", label: "Doctors" },
  { href: "#partners", label: "Partners" },
  { href: "#callback", label: "Request Callback" },
  { href: "#contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = React.useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-cream/80 border-b border-border" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5" data-testid="header-logo">
          <img
            src="/logos/mark_organic.png"
            alt="Dr Du Pré Louw"
            className="w-10 h-10 object-contain"
          />
          <div className="leading-tight">
            <div className="font-display text-lg text-forest">Dr Du Pré Louw</div>
            <div className="text-[10px] tracking-[0.22em] uppercase text-clay font-bold">Family Practice</div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="text-sm text-ink/80 hover:text-clay transition-colors"
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="tel:0212240204"
            className="text-sm text-forest flex items-center gap-1.5"
            data-testid="header-call"
          >
            <Phone className="w-4 h-4" /> 021 224 0204
          </a>
          <Button
            asChild
            className="bg-clay hover:bg-clay-dark text-cream rounded-lg"
            data-testid="header-book-now"
          >
            <a href="https://mygc.co.za/external/diary/b34126f8-72c0-41cf-b8da-d716b2ea8733" target="_blank" rel="noreferrer">
              Book Now
            </a>
          </Button>
        </div>

        <button
          className="md:hidden w-10 h-10 rounded-md border border-border flex items-center justify-center"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-border bg-cream">
          <div className="px-5 py-4 flex flex-col gap-3">
            {navItems.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                className="py-1.5 text-ink/90"
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {n.label}
              </a>
            ))}
            <Button
              asChild
              className="bg-clay hover:bg-clay-dark text-cream mt-2"
              data-testid="mobile-book-now"
            >
              <a href="https://mygc.co.za/external/diary/b34126f8-72c0-41cf-b8da-d716b2ea8733" target="_blank" rel="noreferrer">
                Book Now
              </a>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
